import { createAsyncThunk } from '@reduxjs/toolkit';
import { ClinicsAPI } from 'integration/api/clinics';
import { ClinicsActions } from 'applicaiton/constants/actions';
import { AxiosError } from 'axios';
import { SearchProfessionalsByFiltersSearchCriteriaDto } from '@docbay/schemas';

/**
 *
 * This function is responsible for searching professionals based on the provided filters.
 * It takes in a `SearchProfessionalsByFiltersSearchCriteriaDto` object as input and returns the search results.
 * If there's an error during the API call, it will reject the promise with the error message.
 *
 * @param data - The search criteria to filter professionals
 * @returns The search results or an error message
 */
export const searchProfessionalsByFilters = createAsyncThunk(
  ClinicsActions.searchProfessionalsByFilters,
  async (
    data: SearchProfessionalsByFiltersSearchCriteriaDto,
    { rejectWithValue },
  ) => {
    try {
      const { data: responseData } =
        await ClinicsAPI.searchProfessionalsByFilters(data);
      return responseData;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
